
import { useState, useEffect, useContext, createContext } from "react";


export {
  DeviceContextProvider,
  useDevice, useDeviceUpdate
};


const DeviceContext = createContext<any>( null ); // TODO: Properly fill out

const DeviceUpdateContext = createContext<any>( null ); // TODO: Properly fill out


function useDevice() {
  return useContext( DeviceContext );
}

function useDeviceUpdate() {
  return useContext( DeviceUpdateContext );
}



const USER_ITEM_KEY = "user";

function DeviceContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [isMobile, setIsMobile] = useState<boolean>( false );


  useEffect( () => {
    const checkIfMobile = () =>{
      // TODO: Right now hard-coded value, may not be in sync with CSS (i.e. Header.css's Media Query)
      const match = window.matchMedia( "(max-width: 1090px)" ).matches;
      setIsMobile( match );
      //console.log( "MOBILE?", match );
    };

    // Check on Mount and on Resize
    checkIfMobile();
    window.addEventListener( "resize", checkIfMobile );

    // Cleanup
    return () => window.removeEventListener( "resize", checkIfMobile );
  }, []);

  // ... Persisting State down into Children
  return (
    <DeviceContext.Provider value={ {isMobile} } >
      <DeviceUpdateContext.Provider value={ {} } >
        {children}
      </DeviceUpdateContext.Provider>
    </DeviceContext.Provider>
  )
}















/* */
